/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Center, Container, Flex, Text } from '@chakra-ui/react';
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/km';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import BreadcrumbComponent from '../../../components/BreadcrumbComponent/BreadcrumbComponent';
import { distributionType, distributionValueType } from '../../../components/MarketDevelopment/Miscellaneous/constants';
import GeneralMonthlyDistributionDetail from '../../../components/MarketDevelopment/MonthlyDistributionChannel/General/page';
import LifeMonthlyDistributionDetail from '../../../components/MarketDevelopment/MonthlyDistributionChannel/Life/page';
import MicroMonthlyDistributionDetail from '../../../components/MarketDevelopment/MonthlyDistributionChannel/Micro/page';
import PrintLayout from '../../../components/Print/PrintLayout';
import c from '../../../constant';
import useStore from '../../../store';
import composeQueries from '../../../utils/composeQueries';
import { getReportTitle } from '../Utils';

export default function MonthlyDistributionReportDetailRevision({ detailReportId = null, detailReportType = null }) {
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const id = urlParams.get('id') ?? detailReportId;
	const reportType = urlParams.get('reportType') ?? detailReportType;
	const period = urlParams.get('period') ?? null;
	const reportId = urlParams.get('reportId') ?? null;
	const companyType = urlParams.get('companyType') ?? null;
	const companyId = urlParams.get('companyId') ?? null;
	const { t } = useTranslation();
	const { currentLang: lang } = useStore((state) => state.currentLang);

	useEffect(() => {
		moment.locale(lang === 'kh' ? 'km' : 'en-gb');
	}, [lang]);

	function SpreadSheet() {
		return (
			<>
				{reportType === 'General' && (
					<>
						<GeneralMonthlyDistributionDetail
							id={id}
							patterns={[
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.brokers },
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.individualAgent },
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.corporateAgent },
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.bancassurance },
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.digitalSale },
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.saleStaff },
								{ distributionType: distributionType.numberRisks, distributionValueType: distributionValueType.numberRisks },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.brokers },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.individualAgent },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.corporateAgent },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.bancassurance },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.digitalSale },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.saleStaff },
								{ distributionType: distributionType.claimIncurred, distributionValueType: distributionValueType.number },
								{ distributionType: distributionType.claimIncurred, distributionValueType: distributionValueType.amount },
								{ distributionType: distributionType.claimPaid, distributionValueType: distributionValueType.number },
								{ distributionType: distributionType.claimPaid, distributionValueType: distributionValueType.amount },
								{ distributionType: distributionType.claimDenies, distributionValueType: distributionValueType.number },
								{ distributionType: distributionType.claimDenies, distributionValueType: distributionValueType.amount },
								{ distributionType: distributionType.outstandingClaims, distributionValueType: distributionValueType.number },
								{ distributionType: distributionType.outstandingClaims, distributionValueType: distributionValueType.amount },
							]}
						/>
					</>
				)}
				{reportType === 'Life' && (
					<>
						<LifeMonthlyDistributionDetail
							id={id}
							patterns={[
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.brokers },
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.individualAgent },
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.corporateAgent },
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.bancassurance },
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.digitalSale },
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.saleStaff },
								{ distributionType: distributionType.sumInsured, distributionValueType: distributionValueType.brokers },
								{ distributionType: distributionType.sumInsured, distributionValueType: distributionValueType.individualAgent },
								{ distributionType: distributionType.sumInsured, distributionValueType: distributionValueType.corporateAgent },
								{ distributionType: distributionType.sumInsured, distributionValueType: distributionValueType.bancassurance },
								{ distributionType: distributionType.sumInsured, distributionValueType: distributionValueType.digitalSale },
								{ distributionType: distributionType.sumInsured, distributionValueType: distributionValueType.saleStaff },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.brokers },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.individualAgent },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.corporateAgent },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.bancassurance },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.digitalSale },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.saleStaff },
								{ distributionType: distributionType.claimIncurred, distributionValueType: distributionValueType.number },
								{ distributionType: distributionType.claimIncurred, distributionValueType: distributionValueType.amount },
								{ distributionType: distributionType.claimPaid, distributionValueType: distributionValueType.number },
								{ distributionType: distributionType.claimPaid, distributionValueType: distributionValueType.amount },
								{ distributionType: distributionType.claimDenies, distributionValueType: distributionValueType.number },
								{ distributionType: distributionType.claimDenies, distributionValueType: distributionValueType.amount },
								{ distributionType: distributionType.outstandingClaims, distributionValueType: distributionValueType.number },
								{ distributionType: distributionType.outstandingClaims, distributionValueType: distributionValueType.amount },
								{ distributionType: distributionType.surrenderPolicies, distributionValueType: distributionValueType.number },
								{ distributionType: distributionType.surrenderPolicies, distributionValueType: distributionValueType.amount },
							]}
						/>
					</>
				)}
				{reportType === 'Micro' && (
					<>
						<MicroMonthlyDistributionDetail
							id={id}
							patterns={[
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.brokers },
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.individualAgent },
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.corporateAgent },
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.bancassurance },
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.digitalSale },
								{ distributionType: distributionType.numberPolicies, distributionValueType: distributionValueType.saleStaff },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.brokers },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.individualAgent },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.corporateAgent },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.bancassurance },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.digitalSale },
								{ distributionType: distributionType.grossPremium, distributionValueType: distributionValueType.saleStaff },
								{ distributionType: distributionType.claimIncurred, distributionValueType: distributionValueType.number },
								{ distributionType: distributionType.claimIncurred, distributionValueType: distributionValueType.amount },
								{ distributionType: distributionType.claimPaid, distributionValueType: distributionValueType.number },
								{ distributionType: distributionType.claimPaid, distributionValueType: distributionValueType.amount },
								{ distributionType: distributionType.claimDenies, distributionValueType: distributionValueType.number },
								{ distributionType: distributionType.claimDenies, distributionValueType: distributionValueType.amount },
								{ distributionType: distributionType.outstandingClaims, distributionValueType: distributionValueType.number },
								{ distributionType: distributionType.outstandingClaims, distributionValueType: distributionValueType.amount },
							]}
						/>
					</>
				)}
			</>
		);
	}

	return (
		<PrintLayout>
			<>
				<Container maxW="container.xl" mt="16px" mb="16px">
					{!(detailReportId && detailReportType) && (
						<BreadcrumbComponent
							list={[
								{
									name: 'Insurance Institute Report',
									path: '/company-submission-report',
								},
								{
									name: period,
									path: '/company-submission-report?period=' + period,
								},
								{
									name: getReportTitle(reportId),
									path: composeQueries('/market-development-data?period=' + period + '&reportId=' + reportId, { companyType, companyId }),
								},
								{
									name: 'Detail',
									path: '#',
								},
							]}
						/>
					)}
					<Center mt="5">
						<Box
							w="100%"
							bg="white"
							borderRadius={c.borderRadius}
							border="1px solid #dbdbdb"
							boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
							pb={4}
						>
							<Flex
								className="hidden-print responsive-header-for-table"
								bg="#FAFAFA"
								p="16px"
								pt="8px"
								pb="8px"
								mb="16px"
								alignItems="center"
								justifyContent="space-between"
								borderBottom="1px solid #dbdbdb"
							>
								<Text fontSize="x-large" fontWeight="bold">
									{t('Distribution Channels and Geographical Report for Insurance Company')}
								</Text>
								<Flex>
									<></>
								</Flex>
							</Flex>
							<SpreadSheet />
						</Box>
					</Center>
				</Container>
			</>
		</PrintLayout>
	);
}
